'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('libp2p-record'),
    Record = _require.Record;

var errcode = require('err-code');

var Message = require('../../message');

var utils = require('../../utils');

module.exports = function (dht) {
  var log = utils.logger(dht.peerInfo.id, 'rpc:get-value');
  /**
   * Process `GetValue` DHT messages.
   *
   * @param {PeerInfo} peer
   * @param {Message} msg
   * @returns {Promise<Message>}
   */

  return /*#__PURE__*/function () {
    var _getValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer, msg) {
      var key, response, id, info, _yield$Promise$all, _yield$Promise$all2, record, closer;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              key = msg.key;
              log('key: %b', key);

              if (!(!key || key.length === 0)) {
                _context.next = 4;
                break;
              }

              throw errcode(new Error('Invalid key'), 'ERR_INVALID_KEY');

            case 4:
              response = new Message(Message.TYPES.GET_VALUE, key, msg.clusterLevel);

              if (!utils.isPublicKeyKey(key)) {
                _context.next = 13;
                break;
              }

              log('is public key');
              id = utils.fromPublicKeyKey(key);

              if (dht._isSelf(id)) {
                info = dht.peerInfo;
              } else if (dht.peerStore.has(id)) {
                info = dht.peerStore.get(id);
              }

              if (!(info && info.id.pubKey)) {
                _context.next = 13;
                break;
              }

              log('returning found public key');
              response.record = new Record(key, info.id.pubKey.bytes);
              return _context.abrupt("return", response);

            case 13:
              _context.next = 15;
              return Promise.all([dht._checkLocalDatastore(key), dht._betterPeersToQuery(msg, peer)]);

            case 15:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              record = _yield$Promise$all2[0];
              closer = _yield$Promise$all2[1];

              if (record) {
                log('got record');
                response.record = record;
              }

              if (closer.length > 0) {
                log('got closer %s', closer.length);
                response.closerPeers = closer;
              }

              return _context.abrupt("return", response);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getValue(_x, _x2) {
      return _getValue.apply(this, arguments);
    }

    return getValue;
  }();
};